import { useEffect, useRef } from "preact/hooks";
import { useController } from "../helpers";

export const HighResImage = ({ image, isPreparing, onLoad, useBigImage }) => {
  // Image reference for the high-resolution image
  const ref = useRef();

  // Destructuring methods from the controller
  const { onImageClick, onImageMouseDown, onImageMouseMove, onImageMouseUp, onContextMenu } = useController();

  // Effect to handle the loading of high-resolution image when preparation is needed
  useEffect(() => {
    if (!isPreparing || !ref.current) return;

    const imgElement = ref.current;

    // Set onload callback for image element if a custom onLoad is provided
    imgElement.onload = () => {
      if (onLoad) onLoad();
    };

    // Set the image source and other attributes from data attributes
    imgElement.setAttribute('src', imgElement.dataset.src);
    if (imgElement.dataset.srcset) {
      imgElement.setAttribute('srcset', imgElement.dataset.srcset);
    }
    if (imgElement.dataset.sizes) {
      imgElement.setAttribute('sizes', imgElement.dataset.sizes);
    }

    // Cleanup function to remove the onload callback
    return () => { imgElement.onload = null; };
  }, [isPreparing, onLoad]);

  // Common properties for the image
  const commonProps = {
    ref,
    className: `mwl__slider__image__thumbnail__high-res ${image.orientation}`,
    "data-src": image.src,
    onClick: onImageClick,
    onMouseDown: onImageMouseDown,
    onMouseMove: onImageMouseMove,
    onMouseUp: onImageMouseUp,
    onContextMenu: onContextMenu,
    alt: image.title
  };

  if ( useBigImage && image.srcset && image.src ) {
    image.srcset = image.srcset.replace('-scaled.', '.');
    commonProps['data-srcset'] = image.src.replace('-scaled.', '.');
  }

  return image.srcset && image.sizes ? 
    <img {...commonProps} data-srcset={image.srcset} data-sizes={image.sizes} /> : 
    <img {...commonProps}  />;
};
